"use client";

import { CheckoutProvider } from "@stripe/react-stripe-js/checkout";
import React from "react";

import { CheckoutFormInner } from "./CheckoutFormInner";
import { stripePromise } from "./stripe-promise";
import { EmbeddedStripeCheckoutProps } from "./types";

/**
 * Wires the Checkout Sessions custom-UI form: `CheckoutProvider` +
 * `CheckoutFormInner`. The SetupIntent card form (admin `CardModal` /
 * `CardSetupForm`) uses `@stripe/react-stripe-js` Elements directly instead.
 */
export function EmbeddedStripeCheckout({
  clientSecret,
  formId,
  onPaymentComplete,
  onSubmittingChange,
  onReady,
  onLoadError,
  userEmail,
  successMessage,
  onBeforeConfirm,
  serverUpdate,
}: EmbeddedStripeCheckoutProps) {
  return (
    <CheckoutProvider
      key={clientSecret}
      stripe={stripePromise}
      options={{
        clientSecret,
        elementsOptions: { appearance: { theme: "stripe" } },
      }}
    >
      <CheckoutFormInner
        formId={formId}
        onPaymentComplete={onPaymentComplete}
        onSubmittingChange={onSubmittingChange}
        onReady={onReady}
        onLoadError={onLoadError}
        userEmail={userEmail}
        successMessage={successMessage}
        onBeforeConfirm={onBeforeConfirm}
        serverUpdate={serverUpdate}
      />
    </CheckoutProvider>
  );
}
